<span
  class="tooltip has-tooltip has-tooltip-left has-tooltip-multiline"
  [attr.data-tooltip]="tooltip"
  *ngIf="tooltip"
>
  <i class="icon {{ icon }} is-size-5 has-text-orange"></i>
</span>
